import $ from 'jquery';

export default function bind() {
  $(window)
    .on('load', checkScrolling)
    .on('resize', checkScrolling);
}

function checkScrolling() {
  window.setTimeout(() => {
    // Check actionBar visible
    if ($('.actionBar:visible').length > 0) {
      $('body').addClass('hasActionBar');
    } else {
      $('body').removeClass('hasActionBar');
    }

    // Check Scrollbar
    if (hasScrollBar($('.app'))) {
      $('body').addClass('hasScroll');
    } else {
      $('body').removeClass('hasScroll');
    }
  }, 0);
}

function hasScrollBar($element) {
  const $first = $($element.get(0));
  return $first && $first.scrollHeight > $element.height();
}



// WEBPACK FOOTER //
// ./src/plugins/scroll.js